import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { cx } from "@jugl-web/utils";
import { PlainButton, Popover } from "@jugl-web/ui-kit";
import { ReactComponent as SmileIcon } from "../../icons/smile.svg";
import { ReactComponent as AttachmentsIcon } from "../../icons/attachments.svg";
import { ReactComponent as TextFormattingIcon } from "../../icons/text-formatting.svg";

const toolbarBtnClass =
  "flex items-center justify-center h-8 w-8 rounded hover:bg-gray-100";

interface CommentsInputToolbarProps {
  variant: "mobile" | "web";
  isTextFormattingBarOpen: boolean;
  onTextFormattingToggle: () => void;
  onEmojiSelect: (emoji: string) => void;
  onAttachmentAdd?: () => void;
  hideAttachmentButton: boolean;
  hasAttachments: boolean;
  onIsEmojiPickerOpenChange: (isEmojiPickerOpen: boolean) => void;
  disabled?: boolean;
}

export const CommentsInputToolbar = ({
  variant,
  isTextFormattingBarOpen,
  onTextFormattingToggle,
  onEmojiSelect,
  onAttachmentAdd,
  hideAttachmentButton,
  hasAttachments,
  onIsEmojiPickerOpenChange,
  disabled,
}: CommentsInputToolbarProps) => (
  <div
    className={cx("flex items-center gap-[10px]", {
      "pointer-events-none opacity-50": disabled,
    })}
  >
    {variant !== "mobile" && (
      <Popover
        placement="top-start"
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger
            as={PlainButton}
            ref={triggerRef}
            className={toolbarBtnClass}
            onMouseDown={(e) => e.preventDefault()}
          >
            <SmileIcon />
          </Trigger>
        )}
        onMount={() => onIsEmojiPickerOpenChange(true)}
        onUnmount={() => onIsEmojiPickerOpenChange(false)}
      >
        {({ onClose }) => (
          <Picker
            theme="light"
            data={data}
            skinTonePosition="none"
            previewPosition="none"
            onEmojiSelect={(emoji: { [key: string]: string }) => {
              onEmojiSelect(emoji.native);
              onClose();
            }}
          />
        )}
      </Popover>
    )}

    {!hideAttachmentButton && !hasAttachments && onAttachmentAdd && (
      <PlainButton
        onClick={onAttachmentAdd}
        className={toolbarBtnClass}
        onMouseDown={(e) => e.preventDefault()}
      >
        <AttachmentsIcon />
      </PlainButton>
    )}

    <PlainButton
      onClick={onTextFormattingToggle}
      className={cx(toolbarBtnClass, {
        "bg-grey-200": isTextFormattingBarOpen,
      })}
      onMouseDown={(e) => e.preventDefault()}
    >
      <TextFormattingIcon
        className={
          isTextFormattingBarOpen ? "stroke-primary-800" : "stroke-dark-700"
        }
      />
    </PlainButton>
  </div>
);
